import { render } from "./en.vue?vue&type=template&id=06604fb3"
import script from "./en.vue?vue&type=script&lang=js"
export * from "./en.vue?vue&type=script&lang=js"

import "./en.vue?vue&type=style&index=0&id=06604fb3&lang=css"

import exportComponent from "/Users/zqj/Documents/git/H5/Website/WaterHome/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__